import {shipmentStatusMapping} from './trackshipment.constants'

export const getStatusDescription = (status: string) => {
    if (!status || status === null || status === undefined) return {status, description: '', group: 'document'}

    const statusInfo = shipmentStatusMapping.get(status)
    if (statusInfo) return statusInfo
    else return {status, description: '', group: 'document'}
}

export const getHistoryGrouping = (history: []) => {
    if (!history || history?.length === 0) return []

    const groupedData: Record<string, any[]> = {}

    history.forEach((item) => {
        const {DATE} = item
        if (groupedData[DATE]) {
            // If the date already exists in the groupedData object, push the item to the existing array
            groupedData[DATE].push(item)
        } else {
            // If the date does not exist in the groupedData object, create a new array with the item
            groupedData[DATE] = [item]
        }
    })
    return Object.entries(groupedData).reverse()
}

// Input time format: 0015 (MMSS format)
export const timeFormatter = (time: string) => time.slice(0, 2) + ':' + time.slice(2, time.length)

// Input date format: 04DEC (DDMMM format), year: 2023
export const dateFormatter = (date: string, year: string) => {
    const formattedMonth = date.slice(2, 3) + date.slice(3, 5).toLowerCase()
    const formattedDate = date.slice(0, 2)
    let formattedYear = ''
    if (year?.length > 0) formattedYear = year
    else formattedYear = `20${date.slice(5)}`

    return `${formattedMonth} ${formattedDate}, ${formattedYear}`
}
